// ABC SEO/GEO — Block 5: Login + Subscription paywall (standalone, pre-auth).
// Billing brokered through GoHighLevel. Toggles between Sign-in and Plans.
(function () {
  const { Icon } = window.SGIcons;

  const BULLETS = [
    { icon: 'trending-up', t: 'Track rankings & site health', d: 'Every keyword, page, and crawl issue in one place.' },
    { icon: 'sparkles', t: 'See how AI engines recommend you', d: 'Visibility inside ChatGPT, Perplexity, Gemini & more.', ai: true },
    { icon: 'check', t: 'Plain-English fixes, prioritized', d: 'No SEO degree required — just do the next thing.' },
  ];

  function BrandPanel() {
    return (
      <div style={{ flex: '1 1 46%', minWidth: 320, background: 'var(--sg-grad-navy)', color: '#fff', padding: '48px 52px',
        display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: -60, right: -40, width: 260, height: 260, borderRadius: '50%', background: 'radial-gradient(circle, rgba(124,58,237,0.40), transparent 70%)' }} />
        <div style={{ position: 'absolute', bottom: -80, left: -60, width: 280, height: 280, borderRadius: '50%', background: 'radial-gradient(circle, rgba(37,99,235,0.30), transparent 70%)' }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 11, position: 'relative' }}>
          <span style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--sg-grad-brand)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(37,99,235,0.5)' }}>
            <Icon name="play" size={16} color="#fff" />
          </span>
          <div style={{ fontFamily: 'var(--sg-font-logo)', fontWeight: 600, fontSize: 18 }}>ABC <span style={{ color: 'var(--sg-violet-500)' }}>SEO/GEO</span></div>
        </div>

        <div style={{ margin: 'auto 0', position: 'relative' }}>
          <h1 style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 40, lineHeight: 1.1, letterSpacing: '-0.02em', margin: '0 0 16px', maxWidth: 460 }}>
            See your business the way <span style={{ color: 'var(--sg-violet-500)' }}>AI sees it.</span>
          </h1>
          <p style={{ fontSize: 15.5, color: 'rgba(226,232,240,0.78)', lineHeight: 1.55, margin: '0 0 36px', maxWidth: 440 }}>
            The first platform that tracks classic SEO and your visibility inside AI answer engines — together.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 440 }}>
            {BULLETS.map((b) => (
              <div key={b.t} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                <span style={{ width: 38, height: 38, borderRadius: 11, flex: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  background: b.ai ? 'rgba(139,92,246,0.22)' : 'rgba(255,255,255,0.10)', color: b.ai ? 'var(--sg-violet-500)' : '#fff' }}>
                  <Icon name={b.icon} size={18} strokeWidth={2.2} />
                </span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14.5 }}>{b.t}</div>
                  <div style={{ fontSize: 13, color: 'rgba(226,232,240,0.66)', marginTop: 3, lineHeight: 1.45 }}>{b.d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ position: 'relative', fontSize: 12, color: 'rgba(148,163,184,0.7)' }}>4,000+ Canadian businesses tracked</div>
      </div>
    );
  }

  function SgInput({ label, type, placeholder, value, onChange, onKeyDown, autoFocus }) {
    const [focus, setFocus] = React.useState(false);
    return (
      <label style={{ display: 'block' }}>
        {label && <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--sg-text)', marginBottom: 7 }}>{label}</span>}
        <input type={type} placeholder={placeholder} value={value} onChange={onChange} onKeyDown={onKeyDown} autoFocus={autoFocus} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}
          style={{ width: '100%', height: 46, padding: '0 14px', borderRadius: 'var(--sg-radius-md)', fontFamily: 'var(--sg-font-sans)', fontSize: 14,
            color: 'var(--sg-text)', background: 'var(--sg-card)', border: `1px solid ${focus ? 'var(--sg-blue-500)' : 'var(--sg-border)'}`,
            outline: 'none', boxShadow: focus ? 'var(--sg-ring)' : 'none', transition: 'all 140ms var(--sg-ease)' }} />
      </label>
    );
  }

  function LoginForm({ onPlans, onAuthed }) {
    const clientId = new URLSearchParams(window.location.search).get('login') || '';
    const [pw, setPw] = React.useState('');
    const [busy, setBusy] = React.useState(false);
    const [err, setErr] = React.useState(null);
    const [who, setWho] = React.useState(null);
    React.useEffect(() => { if (clientId) window.SGLive.fetchWhoami(clientId).then(setWho); }, [clientId]);

    const signIn = () => {
      if (busy) return;
      if (!clientId) { setErr('This link is missing its account — please use the link you were given.'); return; }
      if (!pw) { setErr('Enter your password.'); return; }
      setBusy(true); setErr(null);
      window.SGLive.login(clientId, pw).then((r) => {
        setBusy(false);
        if (r.ok) { if (onAuthed) onAuthed(); }
        else setErr(r.message || 'Incorrect password');
      });
    };

    const name = who && who.business_name;

    // Un-enrolled GHL sub-account: no password exists yet. Show a friendly notice
    // instead of a dead password box — the visit itself puts them on the admin's
    // "waiting to enroll" list.
    if (who && who.exists === false) {
      return (
        <div style={{ flex: '1 1 54%', minWidth: 340, background: 'var(--sg-page)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
          <div style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
            <div style={{ width: 52, height: 52, borderRadius: 14, background: 'var(--sg-blue-50)', color: 'var(--sg-blue-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 18 }}><Icon name="clock" size={24} /></div>
            <h2 style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 24, letterSpacing: '-0.02em', color: 'var(--sg-text)', margin: '0 0 10px' }}>Almost there</h2>
            <p style={{ fontSize: 14.5, color: 'var(--sg-text-2)', lineHeight: 1.6, margin: '0 0 8px' }}>
              Your SEO&nbsp;+&nbsp;GEO dashboard for this account isn’t switched on yet. We’ve let AI&nbsp;Biz&nbsp;Connect know you’re here — you’ll get access shortly.
            </p>
            <p style={{ fontSize: 13, color: 'var(--sg-text-3)', margin: '18px 0 0' }}>Expecting to sign in already? Contact your provider to have your account activated.</p>
            <div style={{ fontSize: 11.5, color: 'var(--sg-text-3)', marginTop: 30 }}>Powered by AI Biz Connect</div>
          </div>
        </div>
      );
    }

    return (
      <div style={{ flex: '1 1 54%', minWidth: 340, background: 'var(--sg-page)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          {who && who.logo_url && <img src={who.logo_url} alt="" style={{ height: 40, marginBottom: 18, objectFit: 'contain' }} />}
          <h2 style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 26, letterSpacing: '-0.02em', color: 'var(--sg-text)', margin: '0 0 6px' }}>
            {name ? `Sign in to ${name}` : 'Welcome back'}
          </h2>
          <p style={{ fontSize: 14, color: 'var(--sg-text-2)', margin: '0 0 28px' }}>Enter your password to open your SEO + GEO dashboard.</p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <span style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--sg-text)', marginBottom: 7 }}>Password</span>
              <SgInput type="password" placeholder="••••••••" value={pw} autoFocus
                onChange={(e) => { setPw(e.target.value); if (err) setErr(null); }}
                onKeyDown={(e) => { if (e.key === 'Enter') signIn(); }} />
            </div>
          </div>

          {err && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12, fontSize: 13, color: 'var(--sg-red, #DC2626)' }}>
              <Icon name="alert-triangle" size={15} /> {err}
            </div>
          )}

          <button onClick={signIn} disabled={busy}
            style={{ width: '100%', height: 48, marginTop: 20, border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.65 : 1,
              fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 15, color: '#fff', background: 'var(--sg-grad-brand)', boxShadow: '0 4px 14px rgba(37,99,235,0.32)' }}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>

          <p style={{ textAlign: 'center', fontSize: 13.5, color: 'var(--sg-text-2)', marginTop: 26 }}>
            New here? <a onClick={onPlans} style={{ fontWeight: 700, color: 'var(--sg-blue-600)', cursor: 'pointer' }}>See plans →</a>
          </p>
          <div style={{ textAlign: 'center', fontSize: 11.5, color: 'var(--sg-text-3)', marginTop: 30 }}>Powered by AI Biz Connect</div>
        </div>
      </div>
    );
  }

  // Standalone / passwordless entry. Shown when the app is opened directly
  // (no ?login= GHL scoping). One email box does both jobs: existing accounts
  // get a sign-in link, new emails start a free 14-day trial.
  function MagicForm({ onPlans }) {
    const [email, setEmail] = React.useState('');
    const [busy, setBusy] = React.useState(false);
    const [err, setErr] = React.useState(null);
    const [sent, setSent] = React.useState(false);

    const submit = () => {
      if (busy) return;
      const e = email.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) { setErr('Enter a valid email address.'); return; }
      setBusy(true); setErr(null);
      window.SGLive.startAuth(e).then((r) => {
        setBusy(false);
        if (r.ok) setSent(true);
        else setErr(r.message || 'Something went wrong. Please try again.');
      });
    };

    if (sent) {
      return (
        <div style={{ flex: '1 1 54%', minWidth: 340, background: 'var(--sg-page)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
          <div style={{ width: '100%', maxWidth: 400, textAlign: 'center' }}>
            <div style={{ width: 52, height: 52, borderRadius: 14, background: 'var(--sg-blue-50)', color: 'var(--sg-blue-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 18 }}><Icon name="mail" size={24} /></div>
            <h2 style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 25, letterSpacing: '-0.02em', color: 'var(--sg-text)', margin: '0 0 10px' }}>Check your inbox</h2>
            <p style={{ fontSize: 14.5, color: 'var(--sg-text-2)', lineHeight: 1.6, margin: '0 0 6px' }}>
              We sent a secure sign-in link to <b style={{ color: 'var(--sg-text)' }}>{email.trim()}</b>. It opens your dashboard and expires in 15&nbsp;minutes.
            </p>
            <p style={{ fontSize: 13, color: 'var(--sg-text-3)', margin: '18px 0 0' }}>
              Didn’t get it? Check spam, or <a onClick={() => { setSent(false); setErr(null); }} style={{ fontWeight: 700, color: 'var(--sg-blue-600)', cursor: 'pointer' }}>try again</a>.
            </p>
            <div style={{ fontSize: 11.5, color: 'var(--sg-text-3)', marginTop: 30 }}>Powered by AI Biz Connect</div>
          </div>
        </div>
      );
    }

    return (
      <div style={{ flex: '1 1 54%', minWidth: 340, background: 'var(--sg-page)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
        <div style={{ width: '100%', maxWidth: 380 }}>
          <h2 style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 26, letterSpacing: '-0.02em', color: 'var(--sg-text)', margin: '0 0 6px' }}>Sign in or start free</h2>
          <p style={{ fontSize: 14, color: 'var(--sg-text-2)', margin: '0 0 26px', lineHeight: 1.55 }}>Enter your email and we’ll send a secure link — no password. New here? You’ll start a free 14-day trial.</p>

          <SgInput label="Work email" type="email" placeholder="you@company.com" value={email} autoFocus
            onChange={(e) => { setEmail(e.target.value); if (err) setErr(null); }}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }} />

          {err && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12, fontSize: 13, color: 'var(--sg-red, #DC2626)' }}>
              <Icon name="alert-triangle" size={15} /> {err}
            </div>
          )}

          <button onClick={submit} disabled={busy}
            style={{ width: '100%', height: 48, marginTop: 20, border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.65 : 1,
              fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 15, color: '#fff', background: 'var(--sg-grad-brand)', boxShadow: '0 4px 14px rgba(37,99,235,0.32)' }}>
            {busy ? 'Sending…' : 'Email me a secure link'}
          </button>

          <div style={{ display: 'flex', alignItems: 'center', gap: 7, justifyContent: 'center', marginTop: 16, fontSize: 12, color: 'var(--sg-text-3)' }}>
            <Icon name="lock" size={13} /> Passwordless · link expires in 15 minutes
          </div>

          <p style={{ textAlign: 'center', fontSize: 13.5, color: 'var(--sg-text-2)', marginTop: 24 }}>
            Want to see pricing first? <a onClick={onPlans} style={{ fontWeight: 700, color: 'var(--sg-blue-600)', cursor: 'pointer' }}>View plans →</a>
          </p>
          <div style={{ textAlign: 'center', fontSize: 11.5, color: 'var(--sg-text-3)', marginTop: 24 }}>Powered by AI Biz Connect</div>
        </div>
      </div>
    );
  }

  /* ── pricing ── */
  // Live GHL payment links (Starter carries the 14-day trial). Growth/Agency
  // charge immediately. New keyword tiers: 25 / 100 / 250.
  const PAY_LINKS = {
    Starter: 'https://links.aibizconnect.ca/payment-link/6a3a15f37a7ef176dee58583',
    Growth: 'https://links.aibizconnect.ca/payment-link/6a3a16377a7ef176dee58584',
    Agency: 'https://links.aibizconnect.ca/payment-link/6a3a165b7a7ef176dee58586',
  };
  // Fallback shape only, shown until /auth/plans responds. The server's tier
  // config is authoritative — see fetchPlans below.
  const TIERS = [
    { name: 'Starter', tagline: 'For solo owners getting started', m: 49, popular: false,
      features: ['1 website', '25 keywords researched', '25 tracked rankings', 'Full SEO + GEO analysis', 'Backlinks, competitors & rank tracking', 'Email support'] },
    { name: 'Growth', tagline: 'For businesses serious about growth', m: 149, popular: true,
      features: ['3 websites', '100 keywords researched', '100 tracked rankings', 'Full SEO + GEO analysis', 'White-label client reports', 'Priority support'] },
    { name: 'Agency', tagline: 'For agencies & multi-site teams', m: 399, popular: false,
      features: ['10 websites', '250 keywords researched', '250 tracked rankings', 'Full SEO + GEO analysis', 'Full white-label platform', 'Priority support + onboarding'] },
  ];
  function Pricing({ onBack }) {
    // Prices and allowances come from the server so they always match what the
    // platform enforces.
    const [tiers, setTiers] = React.useState(TIERS);
    React.useEffect(() => {
      window.SGLive.fetchPlans().then((d) => {
        if (Array.isArray(d) && d.length) {
          setTiers(d.map((p) => ({ name: p.name, tagline: p.tagline, m: p.monthly, popular: p.popular, features: p.features })));
        }
      });
    }, []);
    return (
      <div style={{ minHeight: '100vh', width: '100%', background: 'var(--sg-page)', padding: '40px 24px 56px', overflowY: 'auto' }}>
        <div style={{ maxWidth: 1040, margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 11, marginBottom: 26 }}>
            <span style={{ width: 32, height: 32, borderRadius: 9, background: 'var(--sg-grad-brand)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="play" size={14} color="#fff" /></span>
            <div style={{ fontFamily: 'var(--sg-font-logo)', fontWeight: 600, fontSize: 17, color: 'var(--sg-text)' }}>ABC <span style={{ color: 'var(--sg-violet-600)' }}>SEO/GEO</span></div>
            <a onClick={onBack} style={{ marginLeft: 'auto', fontSize: 13.5, fontWeight: 600, color: 'var(--sg-blue-600)', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 5 }}>← Back to sign in</a>
          </div>

          <div style={{ textAlign: 'center', marginBottom: 30 }}>
            <h1 style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 34, letterSpacing: '-0.02em', color: 'var(--sg-text)', margin: '0 0 10px' }}>Choose your plan</h1>
            <p style={{ fontSize: 15, color: 'var(--sg-text-2)', margin: '0 0 4px' }}>Track SEO and AI visibility together. Cancel anytime.</p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 18, alignItems: 'start' }}>
            {tiers.map((t) => {
              const price = t.m;
              return (
                <div key={t.name} style={{ background: 'var(--sg-card)', borderRadius: 'var(--sg-radius-lg)', overflow: 'hidden',
                  border: t.popular ? '2px solid var(--sg-violet-600)' : '1px solid var(--sg-border)',
                  boxShadow: t.popular ? 'var(--sg-shadow-lg)' : 'var(--sg-shadow)', transform: t.popular ? 'translateY(-6px)' : 'none', position: 'relative' }}>
                  {t.popular && <div style={{ background: 'var(--sg-grad-violet)', color: '#fff', textAlign: 'center', fontSize: 11.5, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '7px 0' }}>Most popular</div>}
                  <div style={{ padding: 26 }}>
                    <div style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 20, color: 'var(--sg-text)' }}>{t.name}</div>
                    <div style={{ fontSize: 13, color: 'var(--sg-text-2)', marginTop: 4, marginBottom: 18 }}>{t.tagline}</div>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 4 }}>
                      <span className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 40, letterSpacing: '-0.02em', color: 'var(--sg-text)' }}>${price}</span>
                      <span style={{ fontSize: 14, color: 'var(--sg-text-3)' }}>/mo CAD</span>
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--sg-text-3)', margintop: 4, minHeight: 16 }}>{t.name === 'Starter' ? '14-day free trial, then billed monthly' : 'billed monthly'}</div>

                    <button onClick={() => { const u = PAY_LINKS[t.name]; if (u) window.open(u, '_blank', 'noopener'); }}
                      style={{ width: '100%', height: 46, margin: '20px 0 22px', border: t.popular ? 'none' : '1px solid var(--sg-border-2)', borderRadius: 'var(--sg-radius-pill)', cursor: 'pointer',
                      fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 14.5,
                      color: t.popular ? '#fff' : 'var(--sg-text)', background: t.popular ? 'var(--sg-grad-violet)' : 'var(--sg-card)',
                      boxShadow: t.popular ? '0 6px 16px rgba(124,58,237,0.32)' : 'none' }}>
                      {t.name === 'Starter' ? 'Start 14-day free trial' : `Choose ${t.name}`}
                    </button>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                      {t.features.map((f) => (
                        <div key={f} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', fontSize: 13.5, color: 'var(--sg-text)' }}>
                          <Icon name="check" size={17} color={t.popular ? 'var(--sg-violet-600)' : 'var(--sg-green)'} strokeWidth={2.6} style={{ flex: 'none', marginTop: 1 }} />
                          <span>{f}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--sg-text-3)', marginTop: 26, display: 'inline-flex', gap: 6, width: '100%', justifyContent: 'center', alignItems: 'center' }}>
            <Icon name="check" size={13} color="var(--sg-green)" /> Secure billing handled by GoHighLevel · 14-day free trial · no card to start
          </div>
        </div>
      </div>
    );
  }

  function Auth({ onAuthed }) {
    const [view, setView] = React.useState('login');
    // GHL sub-accounts arrive with ?login=<clientId> → password gate. A direct
    // visit (standalone) has no ?login= → passwordless email/magic-link entry.
    const hasLogin = !!new URLSearchParams(window.location.search).get('login');
    if (view === 'plans') return <Pricing onBack={() => setView('login')} />;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexWrap: 'wrap' }}>
        <BrandPanel />
        {hasLogin
          ? <LoginForm onPlans={() => setView('plans')} onAuthed={onAuthed} />
          : <MagicForm onPlans={() => setView('plans')} />}
      </div>
    );
  }

  // Forced first-login password change — shown after an admin enrolls a sub with a
  // temporary password. Clears the flag on success, then drops into the app.
  function ChangePassword({ onDone }) {
    const [pw, setPw] = React.useState('');
    const [pw2, setPw2] = React.useState('');
    const [busy, setBusy] = React.useState(false);
    const [err, setErr] = React.useState(null);

    const submit = () => {
      if (busy) return;
      if (pw.length < 8) { setErr('Use at least 8 characters.'); return; }
      if (pw !== pw2) { setErr('Those passwords don’t match.'); return; }
      setBusy(true); setErr(null);
      window.SGLive.changeOwnPassword(pw).then((r) => {
        setBusy(false);
        if (r && r.success) { if (onDone) onDone(); }
        else setErr((r && r.error) || 'Could not update your password. Please try again.');
      });
    };

    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexWrap: 'wrap' }}>
        <BrandPanel />
        <div style={{ flex: '1 1 54%', minWidth: 340, background: 'var(--sg-page)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
          <div style={{ width: '100%', maxWidth: 380 }}>
            <div style={{ width: 46, height: 46, borderRadius: 13, background: 'var(--sg-blue-50)', color: 'var(--sg-blue-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}><Icon name="lock" size={21} /></div>
            <h2 style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 26, letterSpacing: '-0.02em', color: 'var(--sg-text)', margin: '0 0 6px' }}>Set your password</h2>
            <p style={{ fontSize: 14, color: 'var(--sg-text-2)', margin: '0 0 26px', lineHeight: 1.55 }}>Welcome! For your security, replace the temporary password you were given with one only you know.</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <SgInput label="New password" type="password" placeholder="At least 8 characters" value={pw} autoFocus
                onChange={(e) => { setPw(e.target.value); if (err) setErr(null); }} />
              <SgInput label="Confirm password" type="password" placeholder="Re-enter it" value={pw2}
                onChange={(e) => { setPw2(e.target.value); if (err) setErr(null); }}
                onKeyDown={(e) => { if (e.key === 'Enter') submit(); }} />
            </div>

            {err && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 12, fontSize: 13, color: 'var(--sg-red, #DC2626)' }}>
                <Icon name="alert-triangle" size={15} /> {err}
              </div>
            )}

            <button onClick={submit} disabled={busy}
              style={{ width: '100%', height: 48, marginTop: 20, border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: busy ? 'default' : 'pointer', opacity: busy ? 0.65 : 1,
                fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 15, color: '#fff', background: 'var(--sg-grad-brand)', boxShadow: '0 4px 14px rgba(37,99,235,0.32)' }}>
              {busy ? 'Saving…' : 'Save password & continue'}
            </button>
            <div style={{ textAlign: 'center', fontSize: 11.5, color: 'var(--sg-text-3)', marginTop: 30 }}>Powered by AI Biz Connect</div>
          </div>
        </div>
      </div>
    );
  }

  window.SGAuth = Auth;
  window.SGChangePassword = ChangePassword;
})();
